(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["store-reviews-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('triscele-store-review-summary')) {
    class TrisceleStoreReviewSummary extends HTMLElement {
      connectedCallback() {
        if (this.reviewObserver) return;
        this.productInfo = this.closest('.m-product-info--wrapper');
        if (!this.productInfo) return;
        this.zeroBadges = new Set();
        this.reviewObserver = new MutationObserver(() => this.syncProductBadges());
        this.reviewObserver.observe(this.productInfo, { childList: true, subtree: true, characterData: true });
        this.syncProductBadges();
      }

      syncProductBadges() {
        const zeroBadges = new Set();
        this.productInfo.querySelectorAll('.main-product__block-title .product-icon-list.vstar-star[data-product-id]').forEach((badge) => {
          const rating = badge.querySelector('.tt-rating-text');
          const text = rating ? rating.textContent.replace(/\s+/g, ' ').trim() : '';
          if (/^0\s+(?:recensioni|reviews?)$/i.test(text)) {
            zeroBadges.add(badge);
            if (badge.getAttribute('data-triscele-zero-reviews') !== 'true') {
              badge.setAttribute('data-triscele-zero-reviews', 'true');
            }
          }
        });
        this.zeroBadges.forEach((badge) => {
          if (!zeroBadges.has(badge)) badge.removeAttribute('data-triscele-zero-reviews');
        });
        this.zeroBadges = zeroBadges;
      }

      disconnectedCallback() {
        if (this.reviewObserver) this.reviewObserver.disconnect();
        if (this.zeroBadges) {
          this.zeroBadges.forEach((badge) => badge.removeAttribute('data-triscele-zero-reviews'));
        }
        this.reviewObserver = null;
        this.zeroBadges = null;
        this.productInfo = null;
      }
    }
    customElements.define('triscele-store-review-summary', TrisceleStoreReviewSummary);
  }
  } catch(e) { console.error(e); }
})();

})();
